import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import './Home.css';

const Home = () => {
  const [postList, setPostList] = useState([]);
  useEffect(() => {
    const getPosts = async () => {
      const data = await getDocs(collection(db, 'posts'));
      // console.log(data);
      console.log(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getPosts();
  }, []);
  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'posts', id));
    // 現在のpostListから、削除したID以外の記事だけを残して上書きする
    // これにより、画面が即座に更新されます
    setPostList(postList.filter((post) => post.id !== id));
  };
  return (
    <div className="homePage">
      {postList.map((post) => {
        return (
          <div className="postContents" key={post.id}>
            <div className="postHeader">
              <h1>{post.title}</h1>
            </div>
            <div className="postTextContainer">{post.postText}</div>
            <div className="nameAndDeleteButton">
              <h3>@{post.author.userName}</h3>
              {post.author.id === auth.currentUser?.uid && <button onClick={() => handleDelete(post.id)}>削除</button>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Home;
